import loadable from '@loadable/component'

import * as paths from 'Constants/paths'

import { LegalLayout } from 'Containers/Layout'

const Legal = loadable(() => import('Containers/Pages/Legal'))
const LegalRoot = loadable(() => import('Containers/Pages/LegalRoot'))

export default [
  {
    component: LegalLayout,
    path: paths.LEGAL,
    routes: [
      {
        path: paths.LEGAL,
        exact: true,
        component: LegalRoot,
      },
      {
        path: paths.CUSTOMER_AGREEMENT_AND_POLICIES,
        exact: true,
        component: Legal,
      },
    ],
  },
]
